module.exports = __webpack_public_path__ + "img/event_tickets_maintenance.11b949ca.png";